import { render, staticRenderFns } from "./addressSelect.vue?vue&type=template&id=f5b0f5f4&scoped=true&"
import script from "./addressSelect.vue?vue&type=script&lang=js&"
export * from "./addressSelect.vue?vue&type=script&lang=js&"
import style0 from "./addressSelect.vue?vue&type=style&index=0&id=f5b0f5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b0f5f4",
  null
  
)

export default component.exports